<template>
  <div>
    <div class="flex order-count-box">
      <img v-if="thisNum > thatNum" class="sh" src="@/assets/images/order/zj.png"/>
      <img v-if="thisNum < thatNum" class="xj" src="@/assets/images/order/xj.png"/>
      <div v-if="thisNum == thatNum" class="ping">—</div>
      <div class="ml5" v-if="thisNum != thatNum">
        <count-to
            :style="`font-size: 16px;font-weight: bold;color: ${thisNum > thatNum ? '#0EBF5C' : '#FE1212'}`"
            :startVal="0"
            :endVal="Math.abs(thisNum - thatNum)"
            :duration="3000">
        </count-to>
        <span v-if="showFh" :style="`color: ${thisNum > thatNum ? '#0EBF5C' : '#FE1212'}`">
          %
        </span>
      </div>
    </div>


  </div>
</template>

<script>
import countTo from "vue-count-to";

export default {
  components: {countTo},
  name: "CounTarrow",
  props: {
    thatNum:{
      default:0,
      type: Number,
    },
    thisNum:{
      default:0,
      type: Number,
    },
    showFh:{
      default:false,
      type:Boolean,
    },
  }
}
</script>

<style scoped>
.order-count-box {
  /*background-color: red;*/
}

.sh, .xj {
  width: 10px;
  height: 15px;
  font-weight: bold;
  margin-top: 4px;
}
</style>